export const formatFechaDeNacimiento = (fecha) => {
	return fecha?.split("-").reverse().join("/");
};

export const formatInscripcionDate = (momento) => {
	const [fecha, hora] = momento.split(" ");

	return formatFechaDeNacimiento(fecha) + " " + hora.slice(0, -3);
};

export const getCurrentDate = () => {
	return new Date()
		.toLocaleString("sv", { timeZoneName: "short" })
		.substring(0, 16);
};
